var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loggedIn && !_vm.firstLoad)?_c('div',[(_vm.user.dashboard == 1)?_c('EditorDashboard'):_vm._e(),(_vm.user.dashboard == 2)?_c('CreatorDashboard'):_vm._e(),(_vm.user.dashboard == 3)?_c('AdminDashboard'):_vm._e()],1):(_vm.loggedIn)?_c('div',[_c('FirstLoadDashboard')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }